import "moment-timezone";
// -
import i18n from "core/i18n";
import IconBool from "components/IconBool";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const translations = {
    es: {
        noData: "No existen configuraciones para los modelos del panel.",
    },
    en: {
        noData: "There are no configurations for the panel models.",
    },
};

const TableConfig = ({
    items,
    itemsShow,
    buttonsTB,
    setButtonsTB,
    setItem,
    checkAll,
    setCheckAll,
    setShowPreview,
    orderingRef,
}) => {
    const stickyCellStyle = {
        position: "sticky",
        top: "164px",
        backgroundColor: "white",
    };

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    return (
        <table className="table table-striped sticky-horizontal">
            <thead>
                <tr>
                    <th
                        key="-1"
                        style={{
                            width: "32px",
                            verticalAlign: "bottom",
                            ...stickyCellStyle,
                        }}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} />
                </tr>
            </thead>
            <tbody id="data-list">
                {itemsShow.length === 0 ? (
                    <tr>
                        <td colSpan="7">
                            <div className="alert alert-secondary text-center">
                                {translations[i18n.language].noData}
                            </div>
                        </td>
                    </tr>
                ) : (
                    itemsShow.map((item) => (
                        <tr key={item.id} data-idx={item.id} onChange={onClick}>
                            <td>
                                <input
                                    type="checkbox"
                                    name="checkboxContainer"
                                    key={item.id}
                                    data-idx={item.id}
                                    defaultChecked={items.current.chosen.includes(
                                        item.id
                                    )}
                                    readOnly={true}
                                />
                            </td>
                            <td>{item.name}</td>
                            <td className="text-center">
                                <IconBool value={item.default} />
                            </td>
                            <td>{item.model}</td>
                            <td>{item.server_name}</td>
                            <td>{item.mqtt_names}</td>
                            <td>{item.ntp_name}</td>
                            <td>{item.gps_name}</td>
                        </tr>
                    ))
                )}
            </tbody>
        </table>
    );
};

export default TableConfig;
